'use strict';

import angular from 'angular';
import ListController from './list.controller';

export default angular.module('updateServerApp.myscripts.list', [])
  .controller('MyScriptsListController', ListController)
  .name;



// WEBPACK FOOTER //
// ./client/app/myscripts/list/index.js